import React from 'react';

/**
 * ONE CONTROL FOR "WITH": a member of staff or, since migration 093, a
 * contractor. Gordon, 24 October: some of the firm's IT contractors have no
 * NCMB account and hold a device all the same, so wherever the register
 * asks who has a device it offers both, grouped - People, then Contractors
 * - in one list rather than two controls that could both be filled in.
 *
 * The value is the holder's key as the API names one ('u:<id>' or
 * 'c:<id>', lib/assets.js holderFields turns it into the field the server
 * reads). Contractors are offered only when meta carries them, which the
 * server does once 093 has run - before that the list is people only, as
 * it always was.
 *
 *   value, onChange(key)   the chosen key, '' for nobody
 *   none                   the first option's words ("Nobody — in stock")
 *   also                   extra choices before the groups, as [{ key, label }]
 *                          - the list's filter adds "Nobody" this way
 *   exclude                a key to leave out (the holder it already has)
 */
export default function HolderSelect({ id, value, onChange, meta, none = 'Nobody', also = [],
  exclude = null, required = false, ...rest }) {
  const people = (meta?.users || []).map((u) => ({ key: `u:${u.id}`, label: u.display_name || u.email }));
  const contractors = (meta?.contractors || []).map((c) => ({
    key: `c:${c.id}`, label: c.company ? `${c.name} · ${c.company}` : c.name
  }));
  const keep = (x) => x.key !== exclude;
  const options = (list) => list.filter(keep).map((x) => <option key={x.key} value={x.key}>{x.label}</option>);
  return (
    <select id={id} value={value || ''} onChange={(e) => onChange(e.target.value)} required={required} {...rest}>
      <option value="">{none}</option>
      {also.map((x) => <option key={x.key} value={x.key}>{x.label}</option>)}
      {contractors.length ? (
        <>
          <optgroup label="People">{options(people)}</optgroup>
          <optgroup label="Contractors">{options(contractors)}</optgroup>
        </>
      ) : options(people)}
    </select>
  );
}
